<template>
  <div class="flex items-center gap-2">
    <div class="bg-gradient-to-br from-primary-500 to-primary-600 rounded-lg p-2">
      <svg 
        class="h-6 w-6 text-white" 
        fill="none" 
        stroke="currentColor" 
        viewBox="0 0 24 24"
      >
        <path 
          stroke-linecap="round" 
          stroke-linejoin="round" 
          stroke-width="2" 
          d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
    </div>
    <span class="text-xl font-bold text-gray-900 dark:text-white">
      ShiftGo
    </span>
  </div>
</template>